
export enum AuctionDetailSnapshotWsEventResponseDtoEvent {
  AuctionDetailSnapshot= 'AuctionDetailSnapshot',

}